<template>
  <div class="page-container" v-loading="loading">
    <img class="image" ref="imageRef" :src="entity.videoUrl">
  </div>
</template>

<script>
import * as SchemeApi from '@/api/scheme';

export default {
  data() {
    return {
      loading: false,
      entity: {},
    }
  },
  created() {
    const id = this.$route.query.id;
    if (id) {
      this.getDetail(id);
    }
  },
  methods: {
    async getDetail(id) {
      this.loading = true;
      try {
        const res = await SchemeApi.getById(id);
        if (res?.code === '00000') {
          this.entity = res.model || {};
          this.$refs['imageRef'].onload = () => {
            this.loading = false;
          };
        }
      } catch (error) {
        console.error('获取详情失败', error);
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.page-container {
  min-height: calc(100vh - @header-height);
  overflow: hidden;
  display: flex;
  justify-content: center;
  .image {
    width: auto;
    height: auto;
  }
}
</style>
